import { render, staticRenderFns } from "./UserDialogInternationalizationTabComponent.vue?vue&type=template&id=04e40858&scoped=true"
import script from "./UserDialogInternationalizationTabComponent.js?vue&type=script&lang=js&external"
export * from "./UserDialogInternationalizationTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./UserDialogInternationalizationTabComponent.vue?vue&type=style&index=0&id=04e40858&prod&scoped=true&lang=scss"
import style1 from "./UserDialogInternationalizationTabComponent.vue?vue&type=style&index=1&id=04e40858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e40858",
  null
  
)

export default component.exports